export function capitalizeSentence(sentence) {
  return sentence?.charAt(0).toUpperCase() + sentence?.slice(1)
}
